import React, { useEffect, useState } from "react";
import "./ProjectNotification.css";
import LanguageContext from "../../helper/LanguageContext";
import { Scrollbars } from "react-custom-scrollbars";
import { connect, useDispatch } from "react-redux";
import {
  OPEN_BOTTOM_PROJECTS,
  OPEN_PROJECTS,
  PROJECT_REQUEST_COUNT,
  PROJECTS,
  UPDATE_PROJECT_ACTION_FIRE,
  ALL_BADGE_COUNT,
  SET_ACTIVITY_MESSAGES_LAST_FETCHED,
} from "../../store";
import { withRouter } from "react-router-dom";
import { MdClose } from "react-icons/md";
import { callAPI } from "../../helper/apiUtils";
import { getBadgeCount } from "../../helper/badgeCount";
import CompanyListDialog from "./Dialogs/CompanyListDialog";
import { $crud } from "../../helper/CrudFactory";
import { EN } from "../../Languages/EN";
import { DE } from "../../Languages/DE";
import { KJUUP_COLORS, BASE_URL, getAvatarInitials } from "../../helper/constants";

const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    backgroundColor: "rgba(var(--kjuup-accent-rgb), 0.8)",
  };
  return <div style={{ ...style, ...thumbStyle }} {...props} />;
};

const CustomScrollbars = (props) => (
  <Scrollbars
    renderThumbHorizontal={renderThumb}
    renderThumbVertical={renderThumb}
    {...props}
  />
);

function ProjectNotification(props) {
  let type = props.type
  const { isGerm, strings } = React.useContext(LanguageContext);
  const dispatch = useDispatch();
  const [companies, setCompanies] = useState([]);
  const [showCompanyDialog, setCompanyDialog] = useState(false);
  const [requestID, setRequestID] = useState("");

  const getCompanies = async () => {
    const { data } = await callAPI(`/company/my`, {}, "GET");
    if (data.status) {
      setCompanies(data.companies);
    }
  };
  const getProjectName = (name) => getAvatarInitials(name);
  console.log(companies)
  useEffect(() => {
    getCompanies();
  }, [props.requests]);
  const confirm = async (user, index) => {
    console.log(user)
    if (type || user.isKjuup) {
      const { data } = await callAPI(
        `/building/${user.requestId}/ApproveProjectJoinRequest`,
        {},
        "POST",
        {
          id: user.requestId,
          companyId: user.company_id,
        }
      );
      console.log(data)
      // Only close if this is the last request
      if (props.requests.length <= 1) {
        props.handleClose()
      }
      if (data.status) {
        $crud.notify({
          type: data.status ? "success" : "error",
          message: data.message,
        });
        props.updateRequests(user.requestId, user.company_id, index, user.isKjuup);
        // Invalidate activity messages cache to trigger reload of latest messages
        dispatch({ type: SET_ACTIVITY_MESSAGES_LAST_FETCHED, payload: 0 });
      }
    }
    else {
      setRequestID(user.requestId);
      if (companies.length > 1) {
        setCompanyDialog(true);
      } else if (companies.length === 1) {
        await submitReJoinCompany(companies[0], user.requestId);
      } else {
        await submitReJoinCompany(null, user.requestId);
      }
    }
  };
  const reject = async (user, index) => {
    console.log(user)
    
    // Optimistic UI update - remove item immediately
    props.updateRequests(user.requestId, user.company_id, index, user.isKjuup);
    
    // Only close if this is the last request
    if (props.requests.length <= 1) {
      props.handleClose()
    }
    
    // Show success toast immediately
    $crud.notify({
      type: "success",
      message: isGerm ? "Anfrage abgelehnt" : "Request rejected",
    });
    
    // Make API call in background
    callAPI(
      `/building/${user.requestId}/RejectProjectJoinRequest`,
      {},
      "POST",
      {
        id: user.requestId,
      }
    ).then(() => {
      if (!type) {
        getBadgesCount()
      }
    }).catch((error) => {
      console.error("Error rejecting request:", error)
    });
  };
  const getBadgesCount = async () => {
    const { data } = await getBadgeCount();
    if (data?.status) {
      await props.updateAllBadgeCount(data);
    }
  }
  const submitReJoinCompany = async (company = {}, requestId = null) => {
    const { data } = await callAPI(
      `/building/${requestId}/ApproveProjectJoinRequest`,
      {},
      "POST",
      {
        id: requestId,
        companyId: company?.id,
      }
    );
    // Only close if this is the last request
    if (props.requests.length <= 1) {
      props.handleClose()
    }
    await getBadgesCount()
    if (data.status) {
      $crud.notify({
        type: data.status ? "success" : "error",
        message: data.message,
      });
      props.updateRequests(requestId, null, null, company.isKjuup);
      // Invalidate activity messages cache to trigger reload of latest messages
      dispatch({ type: SET_ACTIVITY_MESSAGES_LAST_FETCHED, payload: 0 });
    }
  };

  return (
    <React.Fragment>
      <div className="pending-requests-panel">
        <div className="pending-requests-header">
          <span>{strings.pending_request}</span>
          <button type="button" className="kj-btn kj-btn--icon kj-btn--sm kj-btn--neutral" onClick={props.handleClose} aria-label={strings.close || "Close"}>
            <MdClose size={18} />
          </button>
        </div>

        <div className="pending-requests-scroll">
          <CustomScrollbars
            autoHide
            autoHideTimeout={200}
            autoHideDuration={200}
            className="bottom-bar"
          >
            <div className="pending-requests-list">
              {props.requests &&
                props.requests.map((user, index) => (
                  <div className="pending-request-row" key={user.requestId || index}>
                    <div
                      className="pending-request-avatar project-notification__avatar"
                      style={{ "--avatar-bg": user.themeColor || "#737373" }}
                    >
                      {getProjectName(user.projectName)}
                    </div>
                    <div className="pending-request-body">
                      <p
                        className="pending-request-text"
                        dangerouslySetInnerHTML={{
                          __html: strings.invited_you_to_join_room
                            .replace('Username', `<span class="pending-request-strong">${user.addedBy}</span>`)
                            .replace('Roomname', `<span class="pending-request-strong">${user.projectName}</span>`)
                        }}
                      />
                      <div className="pending-request-actions">
                        <button
                          type="button"
                          className={`pending-request-confirm kj-btn kj-btn--primary${type ? ' kj-btn--internal' : ''}`}
                          onClick={() => confirm(user, index)}
                        >
                          {strings.confirm}
                        </button>
                        <button
                          type="button"
                          className={`pending-request-reject kj-btn kj-btn--outline kj-btn--on-surface${type ? ' kj-btn--internal' : ''}`}
                          onClick={() => reject(user, index)}
                        >
                          {strings.reject}
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              {props.requests.length <= 0 && (
                <p className="pending-requests-empty">{strings.no_pending_request}</p>
              )}
            </div>
          </CustomScrollbars>
        </div>
        {showCompanyDialog && (
          <CompanyListDialog
            requestId={requestID}
            handleClose={(e) => setCompanyDialog(false)}
            setParam={() => { }}
            companies={companies}
            handleReJoinCompany={submitReJoinCompany}
          />
        )}
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  const {
    projects,
    openProjects,
    updateProjectActionFire,
    openBottomProjects,
  } = state;
  return {
    projects: projects,
    updateProjectActionFire: updateProjectActionFire,
    openProjects: openProjects,
    openBottomProjects: openBottomProjects,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateOpenProjects: (projects) =>
      dispatch({ type: OPEN_PROJECTS, openProjects: projects }),
    updateProjectAction: (value) =>
      dispatch({
        type: UPDATE_PROJECT_ACTION_FIRE,
        updateProjectActionFire: value,
      }),
    updateBottomOpenProjects: (projects) =>
      dispatch({ type: OPEN_BOTTOM_PROJECTS, openBottomProjects: projects }),
    updateProjectRequestCount: (count) =>
      dispatch({ type: PROJECT_REQUEST_COUNT, projectRequestCount: count }),
    updateAllBadgeCount: (count) =>
      dispatch({ type: ALL_BADGE_COUNT, unSeenAllCount: count }),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ProjectNotification));
